import { useLocation, useNavigate } from "react-router-dom";

export const useNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const navigateToRoute = (path, callback) => {
    navigate(path);
    if (callback) callback();
  };

  return {
    currentPath: location.pathname,
    isActiveRoute,
    navigateToRoute,
  };
};
